module.exports = __webpack_public_path__ + "static/media/EN.386cc387.svg";